// extracted by mini-css-extract-plugin
module.exports = {"ModalInput":"ModalInput_ModalInput__ed7fk","Recommendation":"ModalInput_Recommendation__F2TXO","Action":"ModalInput_Action__a6gXz"};